import { Pipe, PipeTransform } from '@angular/core';
import { OrderDto, StatutCommandes } from '@timechef/core/api';
import { ensureDate } from '@timechef/core/utils';
import { isAfter } from 'date-fns';

@Pipe({
  name: 'isOrderValidated',
  standalone: false,
})
export class IsOrderValidatedPipe implements PipeTransform {
  transform(order: Partial<OrderDto>): boolean {
    if (order && order.scorp) {
      return isAfter(new Date(), ensureDate(order.scorp.orderLimitDate)) && order.status === StatutCommandes.ScorpNonPayee;
    }

    return false;
  }
}
